'use client'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>⚠️ App Router Error Boundary</h2>
      <div style={{ 
        padding: '1rem', 
        margin: '1rem auto', 
        maxWidth: '600px',
        backgroundColor: '#ffebee', 
        border: '1px solid #f44336',
        borderRadius: '4px'
      }}>
        <h3>🐛 Something went wrong!</h3>
        <p><strong>Error:</strong> {error.message}</p>
        {error.digest && (
          <p><strong>Digest:</strong> {error.digest}</p>
        )}
      </div>
      
      <button
        onClick={reset}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginTop: '1rem'
        }}
      >
        Try again
      </button>

      <div style={{ marginTop: '2rem' }}>
        <p><strong>✅ Phase 1 Test:</strong> App Router error.tsx is working!</p>
      </div>
    </div>
  )
}